<template>
  <div class="navBar flex">
    <div class="cube flex" v-for="(item, index) in listBat" :key="index">
      <div class="circle_one">
        <img :src="item.pic" />
      </div>
      <div>
        <span>{{ item.name }}</span>
        <div class="valueNum">
          <span class="num">{{ item.value }}</span>
          <span class="ys" v-if="item.unit">({{ item.unit }})</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getScreenV2Hometbzb } from "@/api/home";
export default {
  data() {
    return {
      navList: [],
      list: [],
      xzIndex: 0,
      listBat: [
        {
          name: "实施主体",
          pic: require("images/index/nav/sszt/实施主体.png"),
          value: 10,
          unit: "个"
        },
        {
          name: "园内企业",
          pic: require("images/index/nav/sszt/国内企业.png"),
          value: 56,
          unit: "个"
        },
        {
          name: "国家农业龙头",
          pic: require("images/index/nav/sszt/国家.png"),
          value: 1,
          unit: "个"
        },
        {
          name: "省农业龙头",
          pic: require("images/index/nav/sszt/省.png"),
          value: 9,
          unit: "个"
        },
        {
          name: "地市级农业龙头",
          pic: require("images/index/nav/sszt/地级.png"),
          value: 21,
          unit: "个"
        },
        {
          name: "其他企业",
          pic: require("images/index/nav/sszt/其它.png"),
          value: 25,
          unit: "个"
        }
      ]
    };
  },
  mounted() {
    // this.getData();
  },
  methods: {
    getData() {
      getScreenV2Hometbzb().then(res => {
        this.listBat = res.data;
        this.listBat[0].value = this.listBat[0].value / 10000;
        // this.listBat[0].unit = "万亩";
        // this.listBat[3].value = 69.47;
        this.listBat[0].pic = require("images/index/nav/h_ghmj.png");
        this.listBat[1].pic = require("images/index/nav/h_sszt.png");
        this.listBat[2].pic = require("images/index/nav/h_zjtr.png");
        this.listBat[3].pic = require("images/index/nav/h_jsjd.png");
        this.listBat[4].pic = require("images/index/nav/h_lndn.png");
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.navBar
  position absolute
  color #fff
  right calc(27% - 10px)
  left calc(27% - 10px)
  z-index 1
  top 105px
  justify-content space-around
  font-size .06rem
  height .35rem

.cube
  background url('~images/index/nav/navBg.png') center no-repeat
  background-size 100% 100%
  height 100%
  justify-content center
  // align-items flex-start
  // width 18%
  width 16%
  opacity .9
  // cursor pointer

.valueNum
  color $textColor
.xzBar
  background rgba(11,46,42,0.8)
  box-shadow inset 0px 0px 0.06rem #0ff
.num
  font-size .15rem

.circle_one
  position relative
  margin-right .05rem

  img
    width .25rem
    height .25rem
    vertical-align middle
</style>
